import { Box, Typography } from '@mui/material';
import { AppGlobalClassKeys } from 'app/appGlobalStyles';
import { MprcJoinComponents } from 'components';
import { MprcProgress } from "components/MprcProgress";
import { EnrollStatus } from 'generated/CoreApi_v1';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProgressDetailsDialog } from 'views/lms/student/EnrollmentView/Shared/ProgressDetailDialog';

interface CreditsData {
    progressPercent: number;
    credits: number;
    minCredits: number | null;
    maxCredits: number | null;
    enrollmentId: string;
    status: EnrollStatus;
    isClosed: boolean;
    totalMandatoryComponents: number;
    totalCompletedMandatoryComponents: number;
}

interface IProps {
    variant: "inline" | "block";
    enableShowDetails?: boolean;
    data: CreditsData;
}

export const CreditsResult: React.FC<IProps> = (props) => {

    const { variant, data: { progressPercent, enrollmentId, credits, minCredits = 0, maxCredits, totalMandatoryComponents, totalCompletedMandatoryComponents, status, isClosed }, enableShowDetails = false } = props;

    const { t } = useTranslation("lms");

    const [showDetails, setShowDetails] = useState<boolean>(false);

    const color =
        status == EnrollStatus.Approved || ((minCredits ?? 0) > 0 && credits >= (minCredits ?? 0))
            ? "success"
            : status == EnrollStatus.Reproved
                ? "error"
                : "primary";

    const RenderInline = (
        <>
            <Typography variant="caption" component="span" textTransform="uppercase">
                {t("Student.EnrollmentView.ProgressText")}
            </Typography>
            <Typography variant="caption" fontWeight="bold" component="span" color={`${color}.main`} textTransform="uppercase">
                &nbsp;{t("Student.EnrollmentView.CreditsText", { count: credits })}
            </Typography>
        </>
    );

    const RenderBlock = (
        <>
            <Typography variant="subtitle1" component="span" textTransform="uppercase">
                {t("Student.EnrollmentView.ProgressText")}
            </Typography>
            &nbsp;
            <Typography
                variant="subtitle1"
                fontWeight="bold"
                component="span"
                color={`${color}.main`}
            >
                {t("Student.EnrollmentView.CreditsText", { count: credits })}
            </Typography>

            <MprcProgress
                value={progressPercent}
                color={color}
                helperText={
                    !isClosed &&
                    <MprcJoinComponents
                        separatorVariant="newline"
                        components={[
                            maxCredits != null ? t(`Student.EnrollmentView.CreditsCompletedItemsText${maxCredits == 1 ? "_one" : "_other"}`, { x: credits, y: maxCredits }) : null,
                            (minCredits ?? 0) > 0 ? t("Student.EnrollmentView.MinCreditsText", { count: minCredits ?? 0 }) : null,
                            totalMandatoryComponents > 0 ? <Typography variant="bodyNotice">{t(`Student.EnrollmentView.MandatoryItemsText${totalMandatoryComponents == 1 ? "_one" : "_other"}`, { x: totalCompletedMandatoryComponents, y: totalMandatoryComponents })}</Typography> : null
                        ]}
                    />
                }
            />
        </>
    );

    return (
        <>
            {enableShowDetails && showDetails &&
                <ProgressDetailsDialog
                    enrollmentId={enrollmentId}
                    onClose={() => setShowDetails(false)}
                />
            }
            <Box className={enableShowDetails ? AppGlobalClassKeys.clickable : undefined} onClick={() => enableShowDetails && setShowDetails(true)}>
                {variant == "inline" ? RenderInline : RenderBlock}
            </Box>
        </>
    );
};
